export var tgfDialogs = {};
tgfDialogs.inherit = function (C, P) {
    if (P === undefined) {
        throw "Attempt to inherit from undefined";
    }
    if (C === undefined) {
        throw "Attempt to inherit to undefined";
    }
    var F = function () { };
    F.prototype = P.prototype;
    C.prototype = new F();
    C.uber = P.prototype;
    C.prototype.constructor = C;
};
